<lcs-loading-overlay [show]="loading | lcsCallState : 'loading'">
   <div class="password-reset-wrapper">
      <form class="password-reset" [formGroup]="form">
         <ndt-logo></ndt-logo>
         <h4 class="login-header">Reset your password</h4>
         <p>Please enter and confirm your new password.</p>
         <div class="login-form-controls">
            <ndt-password-form-control></ndt-password-form-control>
         </div>
         <button type="submit" mat-raised-button (click)="onSubmit()">Reset Password</button>
      </form>
   </div>
</lcs-loading-overlay>
